var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7809 12.091L9.15068 5.98556C9.82977 4.41212 9.47927 2.55628 8.09919 1.2787C6.41972 -0.26784 3.80558 -0.409046 1.94356 0.841634L4.74755 3.43041L3.71066 4.3785L0.913975 1.80318C-0.444205 3.5111 -0.290862 5.92504 1.38861 7.46486C2.74679 8.71554 4.72564 9.04502 6.41972 8.46002L13.0719 14.5857C13.3567 14.8479 13.8167 14.8479 14.1015 14.5857L15.7809 13.0391C16.073 12.7836 16.073 12.36 15.7809 12.091ZM13.5903 13.1669L6.68259 6.8059C6.23717 7.10848 5.74063 7.29003 5.22218 7.35727C4.2291 7.49175 3.18491 7.21607 2.4255 6.51676C1.7318 5.8847 1.41051 5.03746 1.46163 4.20368L3.71796 6.28142L6.81403 3.43041L4.5577 1.35266C5.46315 1.3056 6.37591 1.60146 7.0696 2.23352C7.85822 2.95972 8.1576 3.96161 7.97505 4.89626C7.88743 5.37367 7.66837 5.81746 7.33247 6.21418L14.2329 12.5684L13.5903 13.1669Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.b5303b35315fc86012b8cbfd8ed0c9e6.svg";
export { ForwardRef as ReactComponent };